import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/chevronLeft.svg'


const _hoisted_1 = { class: "genericPadding" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "d-flex flex-column align-items-center mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_val_form = _resolveComponent("val-form")!
  const _directive_localizedPlaceholder = _resolveDirective("localizedPlaceholder")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "backbutton",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
    }, [
      _hoisted_2
    ]),
    _createVNode(_component_localized_text, {
      localizedKey: "app_codiceDiConferma",
      text: "Codice di conferma",
      class: "fs_28 spaceCadet d-block mt-2"
    }),
    _createVNode(_component_localized_text, {
      localizedKey: "app_inserisciilcodicediconfermamail",
      text: "Inserisci il codice di conferma ricevuto per mail",
      class: "fs_16 grey d-block mb-5"
    }),
    _createVNode(_component_val_form, {
      onSubmit: _ctx.sendCode,
      class: "registerContainer"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_3, [
          _withDirectives(_createVNode("input", {
            type: "text",
            class: "genericInput",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.code = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.code],
            [_directive_localizedPlaceholder, {key: 'app_codice', value: 'Codice', afterText : '*'}]
          ])
        ]),
        _createVNode("button", {
          type: "submit",
          class: "genericButton bgGradient w-100 mt-4",
          disabled: !_ctx.code.trim()
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "app_inviailcodice",
            text: "Invia il codice",
            class: "fs_14 white"
          })
        ], 8, ["disabled"])
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_localized_text, {
        localizedKey: "app_nonhairicevutoilcodice?",
        text: "Non hai ricevuto il codice?",
        class: "fs_13 grey"
      }),
      _createVNode("button", {
        type: "button",
        class: "genericButton bgPurple w-100 mt-3",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.requestCode && _ctx.requestCode(...args)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_richiedicodice",
          text: "Richiedi codice",
          class: "fs_14 white"
        })
      ])
    ])
  ]))
}